import React from 'react';

export const Landing = () => {
  return (
    <section id="home" className="relative min-h-screen pt-28 pb-12 md:pt-20 md:pb-0 flex items-center justify-center overflow-hidden">
      <div className="relative z-10 flex flex-col items-center text-center px-4 w-full max-w-4xl mx-auto">
        {/* Background Radial Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[600px] h-[300px] bg-[#f15700] opacity-[0.15] blur-[100px] rounded-full pointer-events-none -z-10"></div>
        
        {/* Top Badge */}
        <div className="flex max-w-full items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 mb-8 hover:bg-white/10 transition-colors cursor-pointer">
          <div className="w-2 h-2 rounded-full bg-[#f15700] animate-pulse"></div>
          <span className="text-sm text-gray-300 font-medium leading-tight">Available for new opportunities</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight text-gray-100 mb-6 flex flex-col md:flex-row items-center gap-2 md:gap-4">
          <span>Hi, I'm</span>
          <span className="hidden md:inline-block text-[#f15700] font-light opacity-50">|</span>
          <span className="text-[#f15700]">Sashank</span>
        </h1>

        {/* Sub Heading */}
        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed">
          Full stack developer building AI agents, modern web apps, and seamless digital experiences. For developers, startups, and enterprises.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-16">
          <a 
            href="/SashankResume.pdf" 
            download 
            className="px-8 py-3.5 rounded-full bg-[#f15700] text-white font-semibold hover:bg-[#d14b00] transition-colors shadow-[0_0_20px_rgba(241,87,0,0.3)] hover:shadow-[0_0_25px_rgba(241,87,0,0.5)]"
          >
            Download CV
          </a>
          <a 
            href="#projects" 
            className="px-8 py-3.5 rounded-full bg-transparent border border-white/10 text-white font-semibold hover:bg-white/5 transition-colors"
          >
            See My Work
          </a>
        </div>

        {/* Bottom Pills */}
        <div className="flex flex-wrap justify-center gap-4">
          <div className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/10 bg-[#0a0a0a]/50 text-gray-300 text-sm hover:border-[#f15700]/50 transition-colors">
            <svg className="w-4 h-4 text-[#f15700]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" /></svg>
            Full Stack Dev
          </div>
          <div className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/10 bg-[#0a0a0a]/50 text-gray-300 text-sm hover:border-[#f15700]/50 transition-colors">
            <svg className="w-4 h-4 text-[#f15700]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" /></svg>
            Scalable Systems
          </div>
          <div className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/10 bg-[#0a0a0a]/50 text-gray-300 text-sm hover:border-[#f15700]/50 transition-colors">
            <svg className="w-4 h-4 text-[#f15700]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
            Modern UI/UX
          </div>
        </div>

        {/* Social Buttons */}
        <div className="flex items-center gap-4 mt-12">
          <a href="https://github.com/Sashankps" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-[#f15700] transition-colors p-2">
            <span className="sr-only">GitHub</span>
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
            </svg>
          </a>
          <a href="https://www.linkedin.com/in/sashank-p-70b633131/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-[#f15700] transition-colors p-2">
            <span className="sr-only">LinkedIn</span>
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};
